export default __webpack_public_path__ + "static/media/liw-landing-buzzmill-logo.6c496422.svg";